import React from "react";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { acresToHectares } from "../../globals/utils";

// Reusable component for detail rows
const DetailRow = ({ label, value, isLast = false }) => (
  <Typography
    variant="body2"
    sx={{
      mb: isLast ? 0 : 0.5,
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <span style={{ fontWeight: 500 }}>{label}:</span>
    <span>{value}</span>
  </Typography>
);

const FarmCard = ({
  farm,
  selectedFarm,
  handleCardClick,
  handleLocationIconClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { id, farm_name, owner_name, area, pin_code, land_record_number } =
    farm;
  const isSelected = selectedFarm?.id === id;

  const onLocationClick = (e) => {
    e.stopPropagation();
    handleLocationIconClick(e, farm);
  };

  return (
    <Card
      elevation={2}
      sx={{
        mb: 1.5,
        cursor: "pointer",
        backgroundColor: isSelected ? "#e8f4fd" : "white",
        borderLeft: isSelected
          ? `4px solid ${theme.palette.primary.main}`
          : "none",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 3,
        },
        borderRadius: 2,
      }}
      onClick={() => handleCardClick(farm)}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0.5,
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ color: theme.palette.primary.main }}
          >
            {farm_name}
          </Typography>
          <LocationOn
            color="secondary"
            fontSize="small"
            sx={{
              cursor: "pointer",
              transition: "transform 0.2s",
              "&:hover": { transform: "scale(1.2)" },
            }}
            onClick={onLocationClick}
          />
        </Box>
        <Divider sx={{ my: 1 }} />

        <DetailRow label={t("Owner")} value={owner_name} />
        <DetailRow
          label={t("Area")}
          value={`${area} ${t("acres")} (${acresToHectares(area)} ${t(
            "hectares"
          )})`}
        />
        <DetailRow label={t("Pin")} value={pin_code || t("n/a")} />
        <DetailRow
          label={t("Record Number")}
          value={land_record_number || t("n/a")}
          isLast={true}
        />
      </CardContent>
    </Card>
  );
};

export default FarmCard;
